module.exports = __webpack_public_path__ + "img/hottel.edb5130b.png";